module.exports = __webpack_public_path__ + "static/media/youtube.df26322e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/LayoutFooter/youtube.svg
// module id = 509
// module chunks = 2